// @flow
import {ButtonPrimary} from '@homeaway/react-buttons';
import {compose} from 'redux';
import Modal from '@homeaway/react-modal';
import {injectIntl, type IntlShape, FormattedMessage} from 'react-intl';
import React from 'react';
import type {Node} from 'react';

import './FormModal.less';

type Props = {
    /* place any template in children that might need a 'submit' and/or a 'reset' experience */
    children: Node,
    isBodyCTA?: boolean,
    headingLabel: string,
    intl: IntlShape,
    isOpen: boolean,
    modalId: string,
    /* controls whether the reset button is visible */
    resetVisible?: boolean,
    submitDisabled?: boolean,
    submitLabel: string | Node,
    onClose: Function,
    onSubmit: Function,
    onReset?: Function
};

export const FormModal = (props: Props) => {
    const {
        isBodyCTA,
        headingLabel,
        intl: {formatMessage},
        isOpen,
        modalId,
        resetVisible,
        submitDisabled,
        submitLabel,
        onClose,
        onSubmit,
        onReset
    } = props;

    const title = (
        <span className={'FormModal__title'}>
            <span>{headingLabel}</span>
            {resetVisible && (
                <button
                    data-wdio="FormModal__clear"
                    onClick={onReset}
                    onKeyDown={onReset}
                >
                    <FormattedMessage
                        id="formModalResetLabel"
                        description="Button to reset form modal"
                        defaultMessage="Clear"
                    />
                </button>
            )}
        </span>
    );

    const closeText = formatMessage({
        id: 'formModalCloseText',
        defaultMessage: 'Cancel',
        description: 'Screen reader text for closing out form modal'
    });

    const ctaButton = (
        <ButtonPrimary
            key="modal-child-ctaButton"
            data-wdio="modal-cta-button"
            block
            disabled={submitDisabled}
            label={submitLabel}
            onClick={onSubmit}
        />
    );

    let children = props.children;
    let footer = ctaButton;

    if (isBodyCTA === true) {
        children = [props.children, ctaButton];
        footer = null;
    }

    return (
        <div className="FormModal">
            <Modal
                closeText={closeText}
                id={modalId}
                isOpen={isOpen}
                onClose={onClose}
                title={title}
                footer={footer}
                {...props}
                closeOnOutsideClick
                closeOnEsc
                isWorkflow
            >
                {children}
            </Modal>
        </div>
    );
};

export default compose(injectIntl)(FormModal);
